import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Artists from "./pages/Artists";
import ArtistDetail from "./pages/ArtistDetail";
import Annex from "./pages/Annex";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ArtworkDetail from "./pages/ArtworkDetail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./lib/i18n";
import { Toaster } from "./components/ui/sonner";

// Header/Footer are hidden on /admin routes so the dashboard fills the screen.
const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main className={isAdmin ? "" : "pt-20"}>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ScrollToTop />
            <Chrome>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/piece/:kind/:slug" element={<ArtworkDetail />} />
                <Route path="/artists" element={<Artists />} />
                <Route path="/artists/:slug" element={<ArtistDetail />} />
                <Route path="/annex" element={<Annex />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </Chrome>
            <Toaster />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
